module.exports = __webpack_public_path__ + "static/media/day_logo.7e97a872.svg";